import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const ProductFamilies = React.lazy(() => import('.'));

export const productFamiliesRoutes = [
  new Route({
    path: 'product-families',
    element: ProductFamilies,
    children: [],
  }),
];
